/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AuthResponse } from '../models/AuthResponse';
import type { SubscriptionCode } from '../models/SubscriptionCode';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SubscriptionCodeService {
    /**
     * Get Subscription Code
     * @param code
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getSubscriptionCodeSubscriptionCodeAvailableCodeGet(
        code: string,
    ): CancelablePromise<(SubscriptionCode | null)> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/subscription_code/available/{code}',
            path: {
                'code': code,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Claim Subscription Code
     * @param code
     * @returns AuthResponse Successful Response
     * @throws ApiError
     */
    public static claimSubscriptionCodeSubscriptionCodeClaimCodePost(
        code: string,
    ): CancelablePromise<AuthResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/subscription_code/claim/{code}',
            path: {
                'code': code,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
